<template>
    <div>
        <h3>
            Attestation

            <button 
                class="btn btn-default btn-sm pull-right"
                v-if="!isEditing"
                :disabled="anyFormDisplayed"
                @click="displayEditionForm"
            >
                Modifier
            </button>
        </h3>

        <div v-if="customerId && declaration">
            <table class="table table-striped table-condensed" v-if="!isEditing">
                <tbody>
                    <tr>
                        <td>
                            <strong>Document en notre possession :</strong>
                        </td>
                        <td>
                            <span :class="{'text-red bold': !declaration.document_in_our_possession}">
                                {{ declaration.document_in_our_possession ? "Oui" : "Non" }}
                            </span>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <strong>Date de réception de la dernière attestation :</strong>
                        </td>
                        <td>
                            <span 
                                :class="{'text-red bold': newDeclarationRequired}" 
                                v-if="declaration.last_reception_date"
                            >
                                {{ declaration.last_reception_date | moment-date }}
                            </span>

                            <span 
                                class="text-red bold" 
                                v-else
                            >
                                Non renseignée
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>

            <div v-else class="form-container">
                <resource-form
                    ref="declarationUpdateForm"
                    :model="declaration"
                    :schema="form.schema"
                    :triggers="form.triggers"
                    @submit="handleUpdateFormSubmission"
                >
                    <template slot="cancel">
                        <button class="btn btn-default btn-sm" @click.prevent="hideEditionForm">Annuler</button>
                    </template>
                </resource-form>
            </div>
        </div>

        <component-loader v-else></component-loader>
    </div>
</template>

<script type="text/babel">
    import {mapState, mapActions} from "vuex"
    import ResourceForm from 'components/Forms/ResourceForm'
    import ComponentLoader from 'components/ComponentLoader'

    export default {
        name: 'BeneficialOwnersDeclaration',

        props: {
            customerId: {
                type: Number,
                default: null
            }
        },

        components: {
            ResourceForm,
            ComponentLoader
        },

        data() {
            return {
                isEditing: false,

                form: {
                    schema: {
                        fields: [
                            {
                                "type": "checkbox",
                                "label": "Document en notre possession",
                                "model": "document_in_our_possession",
                                "default": false,
                                "disabled": false,
                                "help": "",
                                "hint": ""
                            },
                            {
                                "type": "date",
                                "label": "Date de dernière réception",
                                "model": "last_reception_date",
                                "placholder": "",
                                "format": "yyyy-mm-dd",
                                "disabled": false,
                                "help": "",
                                "hint": "",
                                "required": false
                            }
                        ]
                    },
                    triggers: {
                        "last_reception_date": "document_in_our_possession:1"
                    }
                }
            }
        },

        created() {
            if (this.customerId) {
                this.fetchDeclaration()
            }
        },

        methods: {
            ...mapActions('beneficialOwners', [
                'broadcastFormDisplay',
                'broadcastFormHide',
                'fetchBeneficialOwnersDeclaration',
                'updateBeneficialOwnersDeclaration'
            ]),

            fetchDeclaration() {
                this.fetchBeneficialOwnersDeclaration(this.customerId)
            },

            displayEditionForm() {
                this.isEditing = true
                this.broadcastFormDisplay()
            },
            
            hideEditionForm() {
                this.isEditing = false
                this.broadcastFormHide()
            },

            handleUpdateFormSubmission(event) {
                this.declarationUpdateForm.isLoading = true

                this.updateBeneficialOwnersDeclaration(event.data)
                    .then(() => {
                        this.hideEditionForm()
                        this.$emit('declaration-updated')
                    })
                    .catch(() => {})
                    .then(() => this.declarationUpdateForm.isLoading = false)
            }
        },

        computed: {
            ...mapState('beneficialOwners', {
                'anyFormDisplayed': 'formDisplayed',
                'declaration': 'declaration'
            }),

            newDeclarationRequired() {
                const lastExpirationDate = moment(this.declaration.last_reception_date)
                const aYearAgo = moment().subtract(1, 'year')

                return lastExpirationDate.isBefore(aYearAgo)
            },

            declarationUpdateForm() {
                return this.$refs.declarationUpdateForm
            }
        },

        watch: {
            customerId(newValue, oldValue) {
                if (newValue && newValue != oldValue) {
                    this.fetchDeclaration()
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    td, th {
        padding: 5px;
    }

    .alert-info {
        background-color: #d9edf7;
        border-color: #d9edf7;
        color: #31708f;
    }

    .form-group-default.input-group {
        width: 100%;
    }
    
    .form-container {
        padding: 15px;
        background-color: #fafafa;    
    }
</style>



// WEBPACK FOOTER //
// client/components/BeneficialOwners/BeneficialOwnersDeclaration.vue